import React, { useRef, useState } from 'react';

import useOnClickOutside from '@components/common/hooks/useOnClickOutside';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import MoreIcon from '@components/common/MoreIcon/MoreIcon';
import Spinner from '@components/common/Spinner/Spinner';
import CustomizeForm from '@components/lpc/Pot/MainModule/Informations/GreetingCard/CustomizeForm/CustomizeForm';
import { personRoles } from '@models/PotModel/personRoles';

import css from './GreetingCardAction.module.scss';

type GreetingCardActionProps = {
    potRef: string;
    personRole: string;
    isActivated: boolean;
    onActivate: (boolean) => void;
    onDeActivate: (boolean) => void;
    showPreview: () => void;
    isLoading: boolean;
    showPreviewButton: boolean;
    hasDarkThemedGreetingCard: boolean;
    hasAnimatedGreetingCardPO: boolean;
    potCategory: string;
};

const GreetingCardAction = ({
    personRole,
    potRef,
    isActivated,
    onActivate,
    showPreview,
    onDeActivate,
    isLoading,
    showPreviewButton,
    hasDarkThemedGreetingCard,
    hasAnimatedGreetingCardPO,
    potCategory,
}: GreetingCardActionProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    const actionMoreRef = useRef();
    useOnClickOutside(actionMoreRef, () => setIsPopUpOpen(false));

    const [isPopUpOpen, setIsPopUpOpen] = useState(false);
    const [openCustomizeForm, setOpenCustomizeForm] = useState(false);

    return (
        <>
            <CustomizeForm
                hasDarkThemedGreetingCard={hasDarkThemedGreetingCard}
                hasAnimatedGreetingCardPO={hasAnimatedGreetingCardPO}
                isVisible={openCustomizeForm}
                onHide={() => setOpenCustomizeForm(false)}
                potRef={potRef}
                potCategory={potCategory}
            />

            <div ref={actionMoreRef} className={css.notification__action}>
                {personRole === personRoles.ORGANISER && (
                    <MoreIcon
                        customClassContainer={css.notification__action__more}
                        customClassIcon={css.notification__action__more__icon}
                        onOpen={() => setIsPopUpOpen(!isPopUpOpen)}
                        icon={'/front-static/icons/action/more-horizontal-brand-primary.svg'}
                    />
                )}

                <div className={`${css.popup} ${isPopUpOpen && css.popup__open}`}>
                    <span className={css.cta} onClick={() => setOpenCustomizeForm(true)}>
                        {t('greeting-card.custom')}
                    </span>
                    <span
                        className={`${css.cta} ${isActivated ? css.cta__error : css.cta__success}`}
                        onClick={() => (isActivated ? onDeActivate(true) : onActivate(false))}
                    >
                        {isLoading ? (
                            <Spinner />
                        ) : isActivated ? (
                            t(t('greeting-card.deactivate'))
                        ) : (
                            t('greeting-card.activate')
                        )}
                    </span>
                    {showPreviewButton && (
                        <span className={css.cta} onClick={() => showPreview()}>
                            {t('greeting-card.preview')}
                        </span>
                    )}
                </div>
            </div>
        </>
    );
};

export default GreetingCardAction;
